<div *ngIf="checkViewMode('edit') && canView()" class="form-group">
  <label for="">
    {{ getTitle() }}
    <span class="error-indication" *ngIf="isRequired()">{{uploadErrorText}}</span>
    <div *ngIf="getOptionByKey(attribute,'tooltip')"
      class="popover-info"
      [popover]="getOptionByKey(attribute,'tooltip')"
    placement="right"
    container="body"
    triggers="mouseenter:mouseleave">
      <i class="fa fa-question-circle"></i>
    </div>
  </label>
  <div [class.has-error]="isRequired() && isEmpty()">
    <dropzone class="upload-dropzone"
      [disabled]="uploadDisabled"
      [config]="config"
      [message]="defaultMessage"
      (error)="onUploadError($event)"
      (success)="onUploadSuccess($event, attribute)"
      (complete)="onUploadComplete($event)">
    </dropzone>
  </div>
</div>

<p *ngIf="checkViewMode('view')" class="d-print-none">
  <span>{{getOptionByKey(attribute,'hideTitle') == 'true'? '' : getTitle() }} </span>
  {{attribute.value}}
</p>

<div *ngIf="checkViewMode('view')" class="d-print-none">
  <!-- Arquivos -->
  <div *ngIf="hasNonImages" class="box-files-uploaded">
    <div *ngFor="let file of getNonImageFiles(); let index = index" class="files-uploaded">
      <div class="images-uploaded-container">
        <div class="images-uploaded">
          <a [href]="getPath(file.key)" target="_blank"><img src="../../../../../../assets/img/file.png" width="50px"
              class="images-uploaded-item"></a>
          <div class="desc-uploaded">
            <div *ngFor="let item of file.attributes" class="images-uploaded-item">
              <a *ngIf="item.key=='fileName'" [href]="getPath(file.key)" target="_blank" class="file-name">{{item.value}}</a>
              <span *ngIf="item.key=='title'">{{item.value}}</span>
              <a *ngIf="item.key=='title'" role="button" data-toggle="collapse" [href]="'#'+getName(attribute.key)+'_'+index" aria-expanded="false" aria-controls="desc1">
                Ver Descrição
              </a>
              <div *ngIf="item.type=='textarea'" class="collapse" [id]="getName(attribute.key)+'_'+index">
                <p>{{item.value}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ngx-gallery *ngIf="hasImages" [options]="galleryOptions" [images]="galleryImages" class="ngx-gallery"></ngx-gallery>
</div>

<div>
  <div>
    <div *ngIf="checkViewMode('edit')" class="edit edit-drag" dndDropzone [dndHorizontal]="layout.dndHorizontal" dndEffectAllowed="copyMove" (dndDrop)="onDrop($event, attribute.attributes)">
      <div dndPlaceholderRef class="dndPlaceholder"></div>
      <div *ngFor="let file of attribute.attributes;let index = index"
        [dndDraggable]="file"
        [dndEffectAllowed]="'move'"
        (dndStart)="onDragStart($event)"
        (dndCopied)="onDragged(file, attribute.attributes, 'copy')"
        (dndLinked)="onDragged(file, attribute.attributes, 'link')"
        (dndMoved)="onDragged(file, attribute.attributes, 'move')"
        (dndCanceled)="onDragged(file, attribute.attributes, 'none')"
        (dndEnd)="onDragEnd($event)"
        >
        <div *ngIf="file.type.toLocaleLowerCase()=='png' || file.type.toLocaleLowerCase()=='jpg' || file.type.toLocaleLowerCase()=='jpeg' || file.type.toLocaleLowerCase()=='pjpeg' || file.type.toLocaleLowerCase()=='bmp' || file.type.toLocaleLowerCase()=='tiff' || file.type.toLocaleLowerCase()=='gif' || file.type.toLocaleLowerCase()=='webp' || file.type.toLocaleLowerCase()=='svg'" >
          <div class="images-uploaded-container">
            <div class="images-uploaded-options">
                <i class="fa fa-bars" dndHandle></i>
                <button (mousedown)="$event.stopPropagation()" (touchstart)="$event.stopPropagation()" (dragstart)="$event.stopPropagation()" (click)="onDelete(file)" type="button" class="upload-remove"><i class="fa fa-trash"></i></button>
              </div>
            <div class="images-uploaded">
              <div class="image-uploaded images-uploaded-item"
                   [class.ios-thumb-box]="isIOS">
                <img *ngIf="!iosThumbFailed[file.key]"
                     [src]="getPath(file.key)"
                     (error)="onIosThumbError(file.key)" />
                <div *ngIf="isIOS && iosThumbFailed[file.key]"
                     class="ios-thumb-placeholder">
                  Imagem enviada
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="file.type.toLocaleLowerCase()!='png' && file.type.toLocaleLowerCase()!='jpg' && file.type.toLocaleLowerCase()!='jpeg' && file.type.toLocaleLowerCase()!='pjpeg' && file.type.toLocaleLowerCase()!='bmp' && file.type.toLocaleLowerCase()!='tiff' && file.type.toLocaleLowerCase()!='gif' && file.type.toLocaleLowerCase()!='webp' && file.type.toLocaleLowerCase()!='svg'">
          <div class="images-uploaded-container">
            <div class="images-uploaded-options">
              <i class="fa fa-bars" dndHandle></i>
              <button (mousedown)="$event.stopPropagation()" (touchstart)="$event.stopPropagation()" (dragstart)="$event.stopPropagation()" (click)="onDelete(file)" type="button" class="upload-remove"><i class="fa fa-trash"></i></button>
            </div>
            <div class="images-uploaded">
              <div class="image-uploaded images-uploaded-item"
                   [class.ios-thumb-box]="isIOS">
                <a [href]="getPath(file.key)" target="_blank">
                    <img src="../../../../../../assets/img/file.png" width="50px">
                </a>
                <a [href]="getPath(file.key)" class="file-name" download>
                    {{ getFilename(file.attributes) }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="checkViewMode('view')" class="d-none d-print-block">
    <p>
      <span>{{getOptionByKey(attribute,'hideTitle') == 'true'? '' : getTitle() }} </span>
      {{attribute.value}}
    </p>

    <p *ngFor="let file of galleryImages">
        <img src="{{file.medium}}" width="100%" />
    </p>
</div>
